/* tslint:disable */
/* eslint-disable */
/**
 * 3DSurvey API
 * Frontend API for 3d Survey
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { StorageInfoData } from './StorageInfoData';
import {
    StorageInfoDataFromJSON,
    StorageInfoDataFromJSONTyped,
    StorageInfoDataToJSON,
} from './StorageInfoData';

/**
 * 
 * @export
 * @interface GetStorageInfo200Response
 */
export interface GetStorageInfo200Response {
    /**
     * 
     * @type {boolean}
     * @memberof GetStorageInfo200Response
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetStorageInfo200Response
     */
    error: string;
    /**
     * 
     * @type {StorageInfoData}
     * @memberof GetStorageInfo200Response
     */
    data: StorageInfoData;
}

/**
 * Check if a given object implements the GetStorageInfo200Response interface.
 */
export function instanceOfGetStorageInfo200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "success" in value;
    isInstance = isInstance && "error" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function GetStorageInfo200ResponseFromJSON(json: any): GetStorageInfo200Response {
    return GetStorageInfo200ResponseFromJSONTyped(json, false);
}

export function GetStorageInfo200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStorageInfo200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
        'error': json['error'],
        'data': StorageInfoDataFromJSON(json['data']),
    };
}

export function GetStorageInfo200ResponseToJSON(value?: GetStorageInfo200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'error': value.error,
        'data': StorageInfoDataToJSON(value.data),
    };
}

